// Export filters
export * from './filters'

import _Vue, { PluginFunction } from 'vue'
import * as filters from './filters'

// Types
type FilterName = keyof typeof filters
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FilterFunc = (...args: any) => string
export type VFiltersOptions = Partial<Record<FilterName, FilterFunc>>

const plugin: PluginFunction<VFiltersOptions> = (
  Vue: typeof _Vue,
  options: VFiltersOptions = {}
) => {
  Object.keys(options).forEach(n => {
    Vue.filter(n, options[n as FilterName])
  })
}

export default plugin
